<template>
  <el-dialog
    class="close-reason-dialog"
    :title="as_number"
    width="30%"
    :append-to-body="true"
    :visible.sync="closeDialogVisible"
  >
    <span>关闭理由：</span>
    <el-input v-model="closeReason"></el-input>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="closeDialogVisible = false" size="small">取 消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="confrimClose"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { closeAftersale } from '@/models/aftersaleModel'
export default {
  props: ['boxData'],
  data () {
    return {
      showInbound: true,
      goodsEditform: {},
      as_number: '',
      closeDialogVisible: false,
      closeReason: ''
    }
  },
  methods: {
    async confrimClose () {
      this.closeDialogVisible = false
      let params = {
        reason: this.closeReason,
        as_number: this.as_number
      }
      await closeAftersale(params)
      this.$emit('refreshData')
    }
  }
}
</script>
<style lang="scss">
.close-reason-dialog{
  .el-dialog__body {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bigAftersale/close-reason-dialog.vue